export default "__VITE_ASSET__DLzIBkoo__"